import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role) {
    return <Navigate to={user.must_change_password ? "/admin/change-password" : "/admin"} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(identifier.trim(), password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(res.user.must_change_password ? "/admin/change-password" : "/admin", { replace: true });
    } else {
      setError(res.error || "Invalid credentials");
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-20 bg-[#FAFAFA]">
      <div className="w-full max-w-md bg-white border border-black/5 p-10">
        <div className="flex items-center gap-3 mb-2">
          <Lock size={18} className="text-[var(--brand-primary)]" />
          <span className="text-sm uppercase tracking-[0.2em] text-[#525252]">Sign In</span>
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Welcome back.</h1>
        <p className="mt-2 text-[#525252] text-sm">Use your email or mobile number to continue.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium mb-2">Email or Mobile</label>
            <input data-testid="login-input-email" type="text" required value={identifier}
                   onChange={(e) => setIdentifier(e.target.value)}
                   placeholder="e.g., you@email.com or 9876543210"
                   className="w-full bg-white border border-black/10 rounded-sm px-4 py-3 focus:ring-2 focus:ring-[var(--brand-primary)]/20 focus:border-[var(--brand-primary)] outline-none"/>
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Password</label>
            <input data-testid="login-input-password" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   className="w-full bg-white border border-black/10 rounded-sm px-4 py-3 focus:ring-2 focus:ring-[var(--brand-primary)]/20 focus:border-[var(--brand-primary)] outline-none"/>
          </div>

          {error && <div data-testid="login-error" className="text-sm text-[var(--brand-primary)] bg-[var(--brand-primary)]/5 px-3 py-2 rounded-sm">{error}</div>}

          <button type="submit" disabled={loading} data-testid="login-submit-button"
                  className="w-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-hover)] disabled:opacity-60 text-white px-6 py-3 rounded-sm font-medium transition-colors">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
